import request from '@/utils/request'

// 采购计划列表
export function fetchList (params) {
	return request({
		url: '/scm/goods/demand/plan/list',
		method: 'get',
		params
	})
}

// 生成采购单
export function generateOrder (data) {
	return request({
		url: '/scm/goods/demand/purOrder/generate',
		method: 'post',
		data
	})
}

// 执行采购计划
export function carryOutDemandPlan (data) {
	return request({
		url: '/scm/goods/demand/plan/carryOut',
		method: 'post',
		data
	})
}


// 下载采购单模板
export function downloadTemplate() {
	return request({
		url: '/scm/goods/demand/plan/template',
		method: 'GET',
		responseType: 'blob'
	})
}

// 导入采购单模板
export function importPlan(data) {
	return request({
		url: '/scm/goods/demand/plan/import',
		method: 'POST',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/pcm/plan.js